import React from 'react';
import Button from '../../../../shared/design-system/ui/button';
import { MCPSuccessIcon } from '../../../../shared/svg';
import { accessibleOnClick } from '../../../../shared/utils/accessible-on-click';
import { IProps } from './types';

const MCPAuthSuccess: React.FC<IProps> = ({
  status,
  errorMsg,
  returnUrl,
  showManualLink,
  onManualRedirect,
  onPricingRedirect,
}) => (
  <div className="mcp-auth-success-page">
    <div className="mcp-success-container">
      <div className="mcp-success-logo">
        <svg
          width="192"
          height="45"
          viewBox="0 0 128 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_12932_48828)">
            <path
              d="M7.61433 0.9375C6.55638 0.9375 6.02656 2.19978 6.77464 2.93802L26.4703 22.3745C27.2184 23.1127 28.4975 22.5899 28.4975 21.5458V2.10938C28.4975 1.46217 27.9658 0.9375 27.31 0.9375H7.61433Z"
              fill="url(#paint0_linear_12932_48828)"
            />
            <path
              d="M13.9146 26.3902C14.4756 26.9439 15.435 26.5518 15.435 25.7688V14.707C15.435 14.2216 15.0362 13.8281 14.5443 13.8281H3.3351C2.54164 13.8281 2.14427 14.7748 2.70533 15.3285L13.9146 26.3902Z"
              fill="url(#paint1_linear_12932_48828)"
            />
            <path
              d="M6.10886 28.0622C6.4829 28.4314 7.12245 28.1699 7.12245 27.6479V22.6172C7.12245 22.2936 6.85662 22.0312 6.5287 22.0312H1.43088C0.901903 22.0312 0.636991 22.6624 1.01103 23.0315L6.10886 28.0622Z"
              fill="url(#paint2_linear_12932_48828)"
            />
          </g>
          <path
            d="M42.3448 14.4031C41.0224 14.2167 40.5691 13.9932 40.5691 13.3969C40.5691 12.8379 41.0602 12.4653 41.8914 12.4653C42.7604 12.4653 43.2137 12.8007 43.3271 13.546H45.6695C45.4428 11.4592 43.8938 10.7139 41.8536 10.7139C39.9646 10.7139 38.1889 11.6455 38.1889 13.546C38.1889 15.3346 39.1334 16.0054 41.5892 16.3781C42.9115 16.5644 43.4405 16.8252 43.4405 17.4588C43.4405 18.0922 42.9871 18.4649 42.0048 18.4649C40.9091 18.4649 40.4935 17.9805 40.3802 17.1607H38C38.0755 19.1357 39.549 20.2164 42.0048 20.2164C44.4228 20.2164 45.8962 19.1729 45.8962 17.2352C45.934 15.2974 44.6494 14.7384 42.3448 14.4031Z"
            fill="black"
          />
          <path
            d="M51.4491 10.7515C49.1822 10.7515 47.4443 11.4222 47.2932 13.5836H49.7112C49.8245 12.801 50.2779 12.5774 51.298 12.5774C52.4692 12.5774 52.8092 13.1737 52.8092 14.2543V14.627H51.7513C48.9178 14.627 46.9531 15.4096 46.9531 17.5336C46.9531 19.4341 48.3511 20.254 50.0512 20.254C51.4869 20.254 52.318 19.695 52.847 18.9497V20.0303H55.3405V14.1426C55.3027 11.6458 53.7159 10.7515 51.4491 10.7515ZM52.7714 16.8628C52.7714 17.869 51.9025 18.4652 50.769 18.4652C49.8245 18.4652 49.4467 18.0181 49.4467 17.3846C49.4467 16.4157 50.3157 16.0803 51.7891 16.0803H52.7714V16.8628Z"
            fill="black"
          />
          <path
            d="M58.8595 6.83838H56.3281V20.0673H58.8595V6.83838Z"
            fill="black"
          />
          <path
            d="M64.6354 10.7515C61.953 10.7515 59.875 12.6147 59.875 15.4841V15.6331C59.875 18.5397 61.9152 20.254 64.6732 20.254C67.2045 20.254 68.7913 19.1733 69.0936 17.1983H66.6756C66.5245 17.9808 65.9199 18.4652 64.7488 18.4652C63.3509 18.4652 62.5197 17.6082 62.4441 16.0803H69.0936V15.3723C69.1313 12.1303 67.0156 10.7515 64.6354 10.7515ZM62.5197 14.5152C62.7086 13.2109 63.502 12.4656 64.6354 12.4656C65.8444 12.4656 66.5622 13.1364 66.6378 14.5152H62.5197Z"
            fill="black"
          />
          <path
            d="M74.462 14.4031C73.1397 14.2167 72.6863 13.9932 72.6863 13.3969C72.6863 12.8379 73.1774 12.4653 74.0086 12.4653C74.8776 12.4653 75.331 12.8007 75.4443 13.546H77.7867C77.56 11.4592 76.011 10.7139 73.9708 10.7139C72.0818 10.7139 70.3061 11.6455 70.3061 13.546C70.3061 15.3346 71.2506 16.0054 73.7064 16.3781C75.0287 16.5644 75.5576 16.8252 75.5576 17.4588C75.5576 18.0922 75.1043 18.4649 74.1219 18.4649C73.0263 18.4649 72.6107 17.9805 72.4974 17.1607H70.1172C70.1927 19.1357 71.6662 20.2164 74.1219 20.2164C76.54 20.2164 78.0134 19.1729 78.0134 17.2352C78.0512 15.2974 76.8044 14.7384 74.462 14.4031Z"
            fill="black"
          />
          <path
            d="M84.6241 10.7512C83.075 10.7512 82.0928 11.4965 81.639 12.3908V6.83838H79.0703V20.0673H81.639V14.813C81.639 13.4715 82.4701 12.8007 83.5661 12.8007C84.6993 12.8007 85.1904 13.3969 85.1904 14.6267V20.0673H87.7597V14.2541C87.7218 11.8318 86.4375 10.7512 84.6241 10.7512Z"
            fill="black"
          />
          <path
            d="M93.2692 10.7515C91.0026 10.7515 89.2645 11.4222 89.1135 13.5836H91.5317C91.6448 12.801 92.098 12.5774 93.1181 12.5774C94.2893 12.5774 94.6293 13.1737 94.6293 14.2543V14.627H93.5719C90.7378 14.627 88.7734 15.4096 88.7734 17.5336C88.7734 19.4341 90.1715 20.254 91.8717 20.254C93.3071 20.254 94.1382 19.695 94.6672 18.9497V20.0303H97.1607V14.1426C97.1234 11.6458 95.4984 10.7515 93.2692 10.7515ZM94.592 16.8628C94.592 17.869 93.723 18.4652 92.5891 18.4652C91.6448 18.4652 91.2669 18.0181 91.2669 17.3846C91.2669 16.4157 92.1359 16.0803 93.6092 16.0803H94.592V16.8628Z"
            fill="black"
          />
          <path
            d="M103.703 10.7515C102.154 10.7515 101.171 11.4968 100.718 12.3911V10.9378H98.1484V20.0303H100.718V14.8133C100.718 13.4718 101.549 12.801 102.645 12.801C103.778 12.801 104.269 13.3972 104.269 14.627V20.0676H106.838V14.2543C106.8 11.8321 105.516 10.7515 103.703 10.7515Z"
            fill="black"
          />
          <path
            d="M114.811 12.3163C114.282 11.3847 113.375 10.7512 111.902 10.7512C109.597 10.7512 107.859 12.5026 107.859 15.4838V15.6329C107.859 18.6512 109.635 20.2536 111.864 20.2536C113.224 20.2536 114.357 19.4711 114.811 18.5395V20.0673H117.343V6.83838H114.811V12.3163ZM114.886 15.5583C114.886 17.3843 113.942 18.2786 112.62 18.2786C111.335 18.2786 110.466 17.3843 110.466 15.5955V15.4465C110.466 13.6205 111.26 12.6889 112.695 12.6889C114.093 12.6889 114.886 13.6205 114.886 15.4092V15.5583Z"
            fill="black"
          />
          <path
            d="M125.424 10.9761L123.346 16.4167L121.117 10.9761H118.359L122.024 19.137L120.399 23.1616H122.893C124.841 18.4029 125.932 15.7348 127.88 10.9761H125.424Z"
            fill="black"
          />
          <defs>
            <linearGradient
              id="paint0_linear_12932_48828"
              x1="6.02248"
              y1="23.7992"
              x2="28.2137"
              y2="2.34994"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563EB" />
              <stop offset="1" stopColor="#3B82F6" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_12932_48828"
              x1="6.02248"
              y1="23.7992"
              x2="28.2137"
              y2="2.34994"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563EB" />
              <stop offset="1" stopColor="#3B82F6" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_12932_48828"
              x1="6.02248"
              y1="23.7992"
              x2="28.2137"
              y2="2.34994"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563EB" />
              <stop offset="1" stopColor="#3B82F6" />
            </linearGradient>
            <clipPath id="clip0_12932_48828">
              <rect
                width="28.5001"
                height="28.125"
                fill="white"
                transform="translate(0 0.9375)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div
        className={`mcp-success-card ${
          status === 'error' ? 'mcp-success-card--error' : ''
        } ${
          status === 'plan_restricted' ? 'mcp-success-card--restricted' : ''
        }`}
      >
        {status === 'authorizing' && (
          <>
            <h1 className="mcp-success-title">Completing Authorization...</h1>
            <p className="mcp-success-message">
              Please wait while we connect your account.
            </p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="mcp-success-icon">
              <MCPSuccessIcon />
            </div>
            <h1 className="mcp-success-title">Login Successful!</h1>
            <p className="mcp-success-message">
              You have been authenticated successfully
            </p>
            {returnUrl ? (
              <p className="mcp-success-redirect">Redirecting back...</p>
            ) : (
              <p className="mcp-success-note">You can now close this window</p>
            )}
            {showManualLink && returnUrl && (
              <p className="mcp-success-manual-link">
                <span
                  className="mcp-success-link"
                  {...accessibleOnClick(onManualRedirect)}
                >
                  Click here if you are not redirected automatically
                </span>
              </p>
            )}
          </>
        )}
        {status === 'plan_restricted' && (
          <>
            <h1 className="mcp-success-title">Upgrade Required</h1>
            <p className="mcp-success-message mcp-success-message--restricted">
              {errorMsg}
            </p>
            <div className="mcp-success-actions">
              <Button
                className="mcp-success-pricing-btn"
                isFullWidth
                onClick={onPricingRedirect}
              >
                View Pricing
              </Button>
            </div>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className="mcp-success-title">Authorization Failed</h1>
            <p className="mcp-success-message mcp-success-message--error">
              {errorMsg}
            </p>
          </>
        )}
      </div>
    </div>
  </div>
);

export default MCPAuthSuccess;
